module.exports = __webpack_public_path__ + "static/img/gengduo.ac30e36e.png";